
import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import stores from "@/stores";

@Component({ components: { Multiselect } })
export default class Filters extends Vue {
  @Prop({ default: () => ({}) }) appliedFilters!: any;

  // Filters storing only IDs
  localFilters: any = {
    dateFrom: "",
    dateTo: "",
    users: [] as number[],
    tenants: [] as number[],
    events: [] as string[],
    models: [] as string[],
  };

  // For displaying in multiselect
  selectedUsers: Array<{ name: number; email: string }> = [];
  selectedTenants: Array<{ id: number; name: string }> = [];
  selectedModels: Array<{ id: number; name: string }> = [];

  events: string[] = ['created', 'updated', 'deleted', 'login'];
  users: Array<{ name: number; email: string }> = [];
  tenants: Array<{ id: number; name: string }> = [];
  models: Array<{ id: number; name: string }> = [];

  enableClearFilters: boolean = false;

  mounted() {
    this.localFilters = { ...this.localFilters, ...this.appliedFilters };
    this.mapSelectedFilters();
    this.loadFilters();
  }

  @Emit("updateFilters")
  emitFilters() {
    return this.localFilters;
  }

  @Emit("clearFilters")
  clearFilters() {
    this.localFilters = { dateFrom: "", dateTo: "", users: [], tenants: [], events: [], models: [] };
    this.selectedUsers = [];
    this.selectedTenants = [];
    this.selectedModels = [];
    this.enableClearFilters = false;
    return this.localFilters;
  }

  @Watch("appliedFilters", { deep: true })
  handleAppliedFilters(newVal: any) {
    this.localFilters = { ...this.localFilters, ...newVal };
    this.mapSelectedFilters();
  }

  @Watch("localFilters", { deep: true })
  handleLocalFilters() {
    this.enableClearFilters =
      !!this.localFilters.dateFrom ||
      !!this.localFilters.dateTo ||
      this.localFilters.users.length > 0 ||
      this.localFilters.tenants.length > 0 ||
      this.localFilters.events.length > 0 ||
      this.localFilters.models.length > 0;
  }

  async loadFilters() {
    const response = await stores.ActivityLog.getFilters();
    this.tenants = response.data.tenants;
    this.users = response.data.admins;
    this.events = response.data.events;
    this.models = response.data.models;
    this.mapSelectedFilters();
  }

  mapSelectedFilters() {
    this.selectedTenants = this.tenants.filter(t => this.localFilters.tenants.includes(t.id));
    this.selectedModels = this.models.filter(m => this.localFilters.models.includes(m.id));
    this.selectedUsers = this.users.filter(u => this.localFilters.users.includes(u.email));
  }

  onTenantSelect(selected: any[]) {
    this.selectedTenants = selected;
    this.localFilters.tenants = selected.map(t => t.id);
    this.emitFilters();
  }

  onModelSelect(selected: any[]) {
    this.selectedModels = selected;
    this.localFilters.models = selected.map(t => t.id);
    this.emitFilters();
  }

  onUserSelect(selected: any[]) {
    this.selectedUsers = selected;
    this.localFilters.users = selected.map(u => u.email);
    this.emitFilters();
  }

  // Utility for generating query string
  static generateFilterQuery(filters: any) {
    let query = "";
    for (const key in filters) {
      const value = filters[key];
      if (!value || value.length === 0) continue;
      if (Array.isArray(value)) {
        for (const v of value) {
          query += `filters[${key}][]=${v}&`;
        }
      } else {
        query += `filters[${key}]=${value}&`;
      }
    }
    return query;
  }
}
